module.exports = __webpack_public_path__ + "static/media/elMirador.91725577.webp";